import { checkboxCardSlotRecipe as base } from '@chakra-ui/react/theme';

const baseVariants = base.variants as Record<string, Record<string, unknown>>;

export const checkboxCardSlotRecipe = {
  ...base,
  variants: {
    ...base.variants,
    variant: {
      ...baseVariants.variant,
      pill: {
        root: {
          flex: '0',
          borderRadius: 'full',
          borderWidth: '1px',
          borderColor: 'transparent',
          bg: 'whiteAlpha.50',
          color: 'whiteAlpha.700',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: 'background 0.15s ease',
          _hover: { bg: 'whiteAlpha.100', color: 'white' },
          _checked: {
            bg: 'purple.500/20',
            color: 'purple.200',
            borderColor: 'purple.500/40',
            _hover: {
              bg: 'purple.500/30',
            },
          },
        },
        control: {
          flex: '0',
          px: 3,
          py: 1.5,
          gap: 1.5,
          alignItems: 'center',
        },
        indicator: {
          display: 'none',
        },
        label: {
          fontSize: 'sm',
          fontWeight: '500',
        },
        content: {
          fontSize: 'sm',
          fontWeight: '500',
        },
      },
    },
  },
};
